module.exports = __webpack_public_path__ + "img/4948872414982.d1560176.jpg";